import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private platformId = inject<object>(PLATFORM_ID);
  private dataService = inject(DataService);


  public set token(token: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('token', token);
    }
  }

  public get token(): string {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('token') || '';
    }
    return '';
  }

  public set userData(data: any) {
    localStorage.setItem('userData', JSON.stringify(data));
  }

  public get userData() {
    return JSON.parse(localStorage.getItem('userData') || '{}');
  }
  
  public set userPermissions(data: any) {
    this.dataService.permissions = data;
    localStorage.setItem('userPermissions', JSON.stringify(data));
  }

  public get userPermissions(){
    return JSON.parse(localStorage.getItem('userPermissions') || '{}');
  }

  public removeToken(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    localStorage.removeItem('userPermissions');
  }
}
